import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { ValidateURLParams } from '@/components/validate/ValidateURLParams';
import { HomePage } from '@/components/dashboard/home/home-page';
import DataContext from '@/contexts/DataContext';
import { useLocation } from 'react-router-dom';

import { config } from '@/config';

const metadata = { title: `Home | ${config.site.name}` };

export function Page() {
  const { requestedURL } = useContext(DataContext);
  const location = useLocation();
  return (
    <React.Fragment>
      <Helmet>
        <title>{metadata.title}</title>
      </Helmet>
      <ValidateURLParams >
        <HomePage />
      </ValidateURLParams>
    </React.Fragment>
  );
}
